<template>
    <tis-button
        class="btn-inverted text-sm tracking-wide rounded-sm py-5 px-8 ml-4"
        :url="url"
        :full-redirect="fullRedirect"
        :target="target"
        :title="title"
    >
        {{ text }}
    </tis-button>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';

export default {
  components: {
    TisButton,
  },
  props: ['url', 'target', 'text', 'fullRedirect', 'title'],
};
</script>
